import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_GRAPHQL_URI}`,
  credentials: "include",
  fetchOptions: {
    mode: "cors",
  },
});

const errorLink = onError(({ graphQLErrors, networkError }): any => {
  if (graphQLErrors) {
    const isLimitsUnsupportedError = graphQLErrors.every((err: any) => {
      const message = String(err?.message || "");
      return (
        message.includes('Cannot query field "LIMITS"') ||
        message.includes("Cannot query field 'LIMITS'") ||
        message.includes("Cannot query field LIMITS")
      );
    });

    if (isLimitsUnsupportedError) {
      return null;
    }

    for (const err of graphQLErrors) {
      switch (err?.extensions?.code) {
        case "UNAUTHENTICATED":
          if (
            window.location.pathname === "/reset-password" ||
            window.location.pathname === "/recover-password" ||
            window.location.pathname === "/login" ||
            window.location.pathname === "/registration"
          ) {
            return null;
          }
          return (window.location.href = `/login`);
      }
      if (err.message.includes("You do not have admin privileges"))
        return (window.location.href = `/login`);
    }
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );
  }
  if (networkError) console.error(`[Network error]: ${networkError}`);
});

export const graphqlClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([errorLink, httpLink]),
  defaultOptions: {
    query: {
      fetchPolicy: "network-only",
    },
    mutate: {
      fetchPolicy: "no-cache",
    },
    watchQuery: {
      fetchPolicy: "cache-and-network",
    },
  },
});
